import { useState } from 'react'
import { Button, Flex } from '@chakra-ui/react'

import { Plus } from 'components/icons'
import { useCustomFormViewer } from '../../../contexts/CustomFormViewerManager/Provider'
import CustomFormViewerQuestion from '../../../components/CustomFormViewerQuestion'

export default function SolicitacaoDeGratificacaoPorTitulacaoEspecializacao() {
  const { questions } = useCustomFormViewer()
  const [visibleDependent2, setVisibleDependent2] = useState(false)
  const [visibleDependent3, setVisibleDependent3] = useState(false)
  const [visibleDependent4, setVisibleDependent4] = useState(false)
  const [visibleDependent5, setVisibleDependent5] = useState(false)

  if (!questions) return null

  return (
    <Flex bg="transparent" flexDir="column" gap={2} borderTop="1px solid" borderColor="primary">
      {questions.map((question, index) => {
        const questionAboutDependent = question.title?.includes('Documento')
        const match = question.title?.match(/Documento (\d+) -/)
        let number = null

        if (questionAboutDependent) {
          if (match) {
            number = parseInt(match[1], 10)
          }
        }

        //DOCUMENTO 2
        if (number == 2 && !visibleDependent2) {
          if (question.title == 'Documento 2 - Tipo de documento') {
            return (
              <Button
                key={index}
                onClick={() => setVisibleDependent2(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar documento
              </Button>
            )
          } else {
            return <></>
          }
        }

        //DOCUMENTO 3
        if (number == 3 && !visibleDependent3) {
          if (question.title == 'Documento 3 - Tipo de documento' && visibleDependent2) {
            return (
              <Button
                key={index}
                onClick={() => setVisibleDependent3(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar documento
              </Button>
            )
          } else {
            return <></>
          }
        }

        //DOCUMENTO 4
        if (number == 4 && !visibleDependent4) {
          if (question.title == 'Documento 4 - Tipo de documento' && visibleDependent3) {
            return (
              <Button
                key={index}
                onClick={() => setVisibleDependent4(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar documento
              </Button>
            )
          } else {
            return <></>
          }
        }

        //DOCUMENTO 5
        if (number == 5 && !visibleDependent5) {
          if (question.title == 'Documento 5 - Tipo de documento' && visibleDependent4) {
            return (
              <Button
                key={index}
                onClick={() => setVisibleDependent5(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar documento
              </Button>
            )
          } else {
            return <></>
          }
        }

        return (
          <CustomFormViewerQuestion
            key={index}
            index={index}
            questionsLength={questions.length}
            question={question}
            disabled={false}
          />
        )
      })}
    </Flex>
  )
}
